import { Swiper } from 'swiper';
import { A11y, Navigation, Autoplay } from 'swiper/modules';

class SliderSection extends HTMLElement {
  connectedCallback() {
    this.mainSwiper = this.querySelector('[data-main-swiper]');
    if (!this.mainSwiper) return;

    this.titleSwiper = this.querySelector('[data-title-swiper]');

    this.defaultSwiperOptions = {
      loop: false,
      threshold: 10,
      modules: [A11y, Navigation, Autoplay],
    };

    this.mainSwiperOptions = {
      ...this.defaultSwiperOptions,
    };

    if (this.querySelector('[type="application/json"]')) {
      const options = JSON.parse(
        this.querySelector('[type="application/json"]').textContent || '{}'
      );
      if (options) {
        this.mainSwiperOptions = {
          ...this.mainSwiperOptions,
          ...options,
        };
      }
    }

    this.titleSwiperOptions = {
      ...this.defaultSwiperOptions,
      speed: 1000,
      slidesPerView: 'auto',
    };

    // Call swiper with selected swiper element and options
    this.mainSwiperInstance = new Swiper(this.mainSwiper, this.mainSwiperOptions);

    if (this.titleSwiper) {
      this.titleSwiperInstance = new Swiper(this.titleSwiper, this.titleSwiperOptions);
    }

    // Check if the theme editor is active, so we need to listen to events
    if (!Shopify.designMode) return;

    ['shopify:section:load', 'shopify:block:select', 'shopify:block:deselect'].forEach(
      (eventName) => {
        window.addEventListener(eventName, (event) => {
          this.mainSwiperInstance.update();
          if (this.mainSwiperOptions.navigation) {
            this.mainSwiperInstance.navigation.init();
            this.mainSwiperInstance.navigation.update();
          }
          if (eventName !== 'shopify:section:load') this.handleBlockSelect(event);
        });
      }
    );
  }

  /**
   * Handles the theme editor block change/edit event
   * @param {Object} event
   */
  handleBlockSelect(event) {
    // Check if the slide index is set
    if (!('mainSwiperSlideIndex' in event.target.dataset)) return;

    // Set the slide index based on loop settings or not
    const swipeToSlideIndex = parseInt(event.target?.dataset?.mainSwiperSlideIndex) - 1;

    // Slide to slide based on the data attribute from the event.target
    this.querySelector('[data-main-swiper]')?.swiper?.slideTo(swipeToSlideIndex, 1000);
  }
}

if (!customElements.get('slider-section')) {
  customElements.define('slider-section', SliderSection);
}

class ToSlide extends HTMLButtonElement {
  connectedCallback() {
    this.mainSwiperInstance = this.closest('slider-section')?.querySelector('[data-main-swiper]');
    if (!this.mainSwiperInstance) return;
    this.addEventListener('click', () => {
      this.mainSwiperInstance?.swiper.slideTo(parseInt(this.dataset.slideTo));
    });
    this.mainSwiperInstance?.swiper?.on('slideChange', ({ activeIndex }) => {
      this.classList.remove('active');
      if (this.dataset.slideTo == activeIndex) this.classList.add('active');
    });
  }
}

if (!customElements.get('to-slide')) {
  customElements.define('to-slide', ToSlide, { extends: 'button' });
}
